import moment from 'moment'
import { TitleWrapper, OptionText, SummaryLine } from '@/style-guide'
import common from '@/utils/common'
import { PaymentMethod } from './'
import { BalancePayment } from '@/components'
import { Typography } from 'antd'
import { Networks } from '@/crypto/chain_info/networks'
import { tokenByChainAndAddress } from '@/crypto/chain_info/tokens'

export const PaymentInfo = ({
  booking,
  trip,
  getBooking,
  showPaymentButton,
}) => {
  const getDepositeBalanceDueDate = (booking) => {
    //The date it will be charged is the earlier of either the close of booking date that the host selected or 30 days prior to departure, whichever is earlier
    if (booking.autoChargeDate)
      return moment
        .unix(booking.autoChargeDate)
        .format('MMM DD, YYYY [at] HH:mm A')
    return ''
  }
  const formattedDate = (inputDate, add = null) => {
    let formatted = moment(inputDate)
    if (add) formatted = moment(inputDate).add(add, 'hours')
    return formatted.fromNow()
  }
  const getPaymentStatus = (status) => {
    if (status == 'full') return 'Fully paid'
    else return status || 'Payment information not available'
  }
  const {
    paymentStatus,
    currentDue,
    cryptoPaymentMethod,
    paymentHistory,
    pendingAmount,
    status,
    paymentMethodType,
  } = booking || {}

  const lastPayment =
    paymentHistory?.length > 0
      ? paymentHistory[paymentHistory.length - 1]?.paymentIntent
      : {}
  const network = Networks[cryptoPaymentMethod?.chainId]
  const cryptoNetwork = network?.name
  const cryptoToken = cryptoPaymentMethod
    ? tokenByChainAndAddress(
      cryptoPaymentMethod.chainId,
      cryptoPaymentMethod.token,
    ).symbol
    : null
  const cryptoReceipt =
    network && lastPayment
      ? `${network.blockExplorer}/tx/${lastPayment?.tripshaTransfer?.txnHash}`
      : null
  return (
    <TitleWrapper>
      {['pay', 'full', 'deposit'].indexOf(paymentStatus) && currentDue > 0 ? (
        <>
          {currentDue > 0 && (
            <>
              <Typography.Title level={5}>Amount due</Typography.Title>
              <Typography.Text className="success">
                {status === 'pending'
                  ? 'Request will expire '
                  : 'Current due by '}

                {status === 'approved'
                  ? getDepositeBalanceDueDate(booking)
                  : booking.bookingExpireOn
                    ? moment.unix(booking.bookingExpireOn).fromNow()
                    : formattedDate(booking.createdAt, 72)}
                <span style={{ float: 'right' }}>
                  {common.toCurrency(currentDue)}
                </span>
              </Typography.Text>
              {pendingAmount > 0 && (
                <OptionText size={14} style={{ paddingLeft: 0 }}>
                  Balance due by {getDepositeBalanceDueDate(booking)}
                  <span style={{ float: 'right' }}>
                    {common.toCurrency(pendingAmount)}
                  </span>
                </OptionText>
              )}
              {showPaymentButton && (
                <BalancePayment
                  bookingData={booking}
                  loadPaymentDetails={getBooking}
                />
              )}
              {paymentMethodType == 'cards' && (
                <PaymentMethod
                  booking={booking}
                  trip={trip}
                  getBooking={getBooking}
                />
              )}
            </>
          )}
        </>
      ) : (
        <SummaryLine>
          <Typography.Text>Payment status</Typography.Text>
          <Typography.Text>
            <b>{getPaymentStatus(paymentStatus)}</b>
          </Typography.Text>
        </SummaryLine>
      )}
      {cryptoPaymentMethod && paymentMethodType == 'crypto' && (
        <div>
          <SummaryLine>
            <Typography.Text>&nbsp;</Typography.Text>
          </SummaryLine>

          <SummaryLine>
            <Typography.Text>
              <b>Crypto Payment Details</b>
            </Typography.Text>
          </SummaryLine>
          <SummaryLine>
            <Typography.Text>Crypto Wallet</Typography.Text>
            <Typography.Text>
              <b>{cryptoPaymentMethod.wallet}</b>
            </Typography.Text>
          </SummaryLine>
          <SummaryLine>
            <Typography.Text>Token</Typography.Text>
            <Typography.Text>
              <b>{cryptoToken}</b>
            </Typography.Text>
          </SummaryLine>
          <SummaryLine>
            <Typography.Text>Network</Typography.Text>
            <Typography.Text>
              <b>{cryptoNetwork}</b>
            </Typography.Text>
          </SummaryLine>
          <SummaryLine>
            <Typography.Text>Receipt</Typography.Text>
            <Typography.Text>
              <a target="new" href={cryptoReceipt}>
                <b>View</b>
              </a>
            </Typography.Text>
          </SummaryLine>

          <SummaryLine>
            <Typography.Text>&nbsp;</Typography.Text>
          </SummaryLine>
        </div>
      )}
    </TitleWrapper>
  )
}
